// Подключение Calltouch.
//
// Скрипт намеренно запускается НЕ из index.html, а после первой отрисовки
// React. Причина: подмена номеров работает так, что скрипт при старте
// сканирует страницу и заменяет найденные телефоны. В index.html на тот
// момент лежит только пустой <div id="root"> — номеров ещё нет, заменять
// нечего, и подмена молча не срабатывает.
//
// Функции «повторить подмену» у Calltouch нет, поэтому единственный
// надёжный способ — дождаться, пока номера окажутся в DOM, и только
// потом отдать управление скрипту.

export const CALLTOUCH_MOD_ID = "892tw5zn";

let started = false;

export function initCalltouch(modId = CALLTOUCH_MOD_ID) {
  if (started || typeof window === "undefined") return;
  started = true;

  /* eslint-disable */
  (function (w, d, n, c) {
    w.CalltouchDataObject = n;
    w[n] = function () { w[n]["callbacks"].push(arguments); };
    if (!w[n]["callbacks"]) { w[n]["callbacks"] = []; }
    w[n]["loaded"] = false;
    if (typeof c !== "object") { c = [c]; }
    w[n]["counters"] = c;
    for (var i = 0; i < c.length; i += 1) { p(c[i]); }
    function p(cId) {
      var a = d.getElementsByTagName("script")[0],
        s = d.createElement("script"),
        i = function () { a.parentNode.insertBefore(s, a); },
        m = typeof Array.prototype.find === "function",
        n = m ? "init-min.js" : "init.js";
      s.async = true;
      s.src = "https://mod.calltouch.ru/" + n + "?id=" + cId;
      if (w.opera == "[object Opera]") {
        d.addEventListener("DOMContentLoaded", i, false);
      } else { i(); }
    }
  })(window, document, "ct", modId);
  /* eslint-enable */
}
